import { useContext } from 'react';

import { ActivitiesContext } from './constants';

const useActivitiesContext = () => {
  return useContext(ActivitiesContext);
};

export { ActivitiesContext };
export default useActivitiesContext;
